import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { Button, Form, FormGroup } from 'reactstrap';
import BlockingSpinnerOverlay from 'components/BlockingSpinnerOverlay';
import VerificationField from 'components/fields/VerificationField';

class VerificationCodeForm extends React.Component {
  componentDidMount() {
    const { handleSubmit, onSubmit, submitOnMount } = this.props;
    if (submitOnMount) {
      const submitFn = handleSubmit(onSubmit);
      submitFn();
    }
  }

  render() {
    const {
      handleSubmit,
      onSubmit,
      isRequestPending,
      isLoading,
      isCancelButtonRequired,
      onCancel,
      busyAriaLabel,
    } = this.props;
    const busy = Boolean(isLoading) || Boolean(isRequestPending);

    return (
      <div className="position-relative" aria-busy={busy || undefined}>
        <BlockingSpinnerOverlay
          show={busy}
          ariaLabel={busyAriaLabel}
        />
        <Form onSubmit={handleSubmit(onSubmit)}>
          <VerificationField
            label="Verification Code"
            name="verification"
            required
            disabled={busy}
          />
          <FormGroup>
            {isCancelButtonRequired ? (
              <div style={{ display: 'flex' }}>
                <span style={{ width: '60%' }}>
                  <Button type="submit" disabled={busy} color="primary" block>
                    {busy ? 'Loading...' : 'Continue'}
                  </Button>
                </span>
                <span style={{ width: '40%', textAlign: 'center' }}>
                  <Button
                    type="button"
                    disabled={busy}
                    color="link"
                    style={{
                      fontSize: '15px',
                      fontWeight: 'bold',
                    }}
                    onClick={onCancel}
                    id="cancel-application"
                  >
                    Cancel
                  </Button>
                </span>
              </div>
            ) : (
              <Button type="submit" disabled={busy} color="primary" block>
                {busy ? 'Loading...' : 'Continue'}
              </Button>
            )}
          </FormGroup>
        </Form>
      </div>
    );
  }
}

VerificationCodeForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isRequestPending: PropTypes.bool,
  isLoading: PropTypes.bool,
  submitOnMount: PropTypes.bool,
  isCancelButtonRequired: PropTypes.bool,
  onCancel: PropTypes.func,
  /** Overlay label while code verify, resend, or /api/confirm is in progress */
  busyAriaLabel: PropTypes.string,
};

VerificationCodeForm.defaultProps = {
  isRequestPending: false,
  isLoading: false,
  submitOnMount: false,
  isCancelButtonRequired: false,
  busyAriaLabel: 'Loading...',
};

const ConnectedVerificationCodeForm = reduxForm({ form: 'verification' })(
  VerificationCodeForm,
);

export default ConnectedVerificationCodeForm;
export { VerificationCodeForm as PureVerificationCodeForm };
